import { Typography, Slider } from '@mui/material'
import { Box } from '@mui/system'
import { capitalizeLetters } from '../utils/str'

export interface StrategySlidersProps {
  noBorder?: boolean

  notify?: string | JSX.Element

  name1: string
  slider1: [string, string]
  value1: number
  values1: [number, number]
  title1: string

  name2?: string
  slider2?: [string, string]
  values2?: [number, number]
  value2?: number
  title2?: string

  onChange: (name: string, value: number) => void
}

/**
 * A helper to provide one or two slider for adjusting strategy parameters.
 */
export const StrategySliders = (props: StrategySlidersProps): JSX.Element => {
  const {
    noBorder,
    notify,
    name1,
    slider1,
    values1,
    value1,
    title1,
    name2,
    slider2,
    values2,
    value2,
    title2,
    onChange,
  } = props

  const sx = noBorder ? { ml: -3 } : { mt: 1, p: 2, border: '1px solid rgba(255,255,255,0.3)', borderRadius: 2 }
  return <Box sx={sx}>
      <Box sx={{ textAlign: 'center' }}>
        {notify && <Box sx={{ textAlign: 'left', mb: 2, color: typeof notify === 'string' ? 'error.main' : undefined }}>{notify}</Box>}
        <Typography>{title1}</Typography>
        <Slider
          data-cy={`slider-${capitalizeLetters(name1.split('_').join(' '))}`}
          size="medium"
          sx={noBorder ? { mt: 5, width: '90%' } : { mt: 5, width: '80%' }}
          value={value1}
          min={values1[0]}
          max={values1[1]}
          marks={[
            { value: values1[0], label: <Box sx={{ color: '#A3A3A3', maxWidth: '5rem', display: 'inline-block', whiteSpace: 'wrap' }}>{slider1[0]}</Box> },
            { value: values1[1], label: <Box sx={{ color: '#A3A3A3', maxWidth: '5rem', display: 'inline-block', whiteSpace: 'wrap' }}>{slider1[1]}</Box> },
          ]}
          onChange={(_, value) => onChange(name1, value as number)}
          valueLabelDisplay="on"
        />
      </Box>

      {name2 !== undefined && slider2 && values2 && <>
        <Box sx={{ textAlign: 'center' }}>
          <Typography>{title2}</Typography>
          <Slider
            data-cy="slider-Time Window"
            size="medium"
            sx={{ mt: 5, width: '80%' }}
            value={value2}
            min={values2[0]}
            max={values2[1]}
            marks={[
              { value: values2[0], label: <Box sx={{ color: '#A3A3A3', maxWidth: '5rem', display: 'inline-block', whiteSpace: 'wrap' }}>{slider2[0]}</Box> },
              { value: values2[1], label: <Box sx={{ color: '#A3A3A3', maxWidth: '5rem', display: 'inline-block', whiteSpace: 'wrap' }}>{slider2[1]}</Box> },
            ]}
            onChange={(_, value) => onChange(name2, value as number)}
            valueLabelDisplay="on"
          />
        </Box>
      </>}
  </Box>
}
